module.exports = __webpack_public_path__ + "img/main.cd059257.png";